export default {
  'en': {
    content: {
      lightbox: {
        close: 'Close'
      }
    },
    error: {
      common: {
        header: 'Oops !',
        content: 'Something went wrong. <a onClick="window.location.reload()">Please try again</a> or call us - <a href="tel:18553453744" class="timeout-no">1-855-345-3744</a>.'
      },
      validation: {
        common: 'There was a problem',
        required: {
          text: 'You must complete this field to continue',
          date: 'Please choose a date',
          checkbox: 'You must check this box to continue'
        },
        invalid: {
          character: 'You have entered a character that our system does not recognize. Please try again',
          date: 'The date which you entered is not valid.',
          residenceSinceDate: 'Resident Since date should be prior to Card Expires date'
        }
      }
    }
  },
  'es': {
    error: {
      common: {
        header: 'Oops !',
        content: 'Algo salió mal. <a onClick="window.location.reload()">por favor trate de nuevo</a> o llámenos al - <a href="tel:18553453744" class="timeout-no">1-855-345-3744</a>.'
      },
      validation: {
        common: 'Había un problema',
        required: {
          text: 'Debe completar este campo para continuar',
          date: 'Elija una fecha'
        },
        invalid: {
          character: 'Ingresó un carácter que nuestro sistema no reconoce. Inténtelo nuevamente'
        }
      }
    }
  }
}
